import React from "react";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../../forms";
import { ActionButtons } from "../../../../../forms/ActionButtons";
import { inputs } from "../../../../../inputs/inputConfigs";
import { scopeDataComponentId } from "../Scopes";
import TextInputWithError from "../../../../../inputs/TextInputWithError";
import DecimalInput from "../../../../../inputs/DecimalInput";
import CheckboxWithError from "../../../../../inputs/CheckboxWithError";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: { ...inputs.name, disabled: true },
          grid: { xs: 12 },
        },
        {
          input: {
            InputComponent: TextInputWithError,
            name: "billingApprovalSearchDaysSetting",
            label: "Billing Approval Search Days Setting",
            fullWidth: true,
            required: true,
            InputProps: {
              inputComponent: DecimalInput,
            },
            inputProps: {
              decimalScale: 0,
              allowNegative: false,
            },
          },
          grid: { xs: 6 },
        },
        {
          input: {
            InputComponent: CheckboxWithError,
            name: "twoFactorAuth",
            label: "Two Factor Authentication",
            fullWidth: true,
            required: true,
          },
          grid: { xs: 6 },
        },
        {
          input: {
            InputComponent: TextInputWithError,
            name: "rememberLoginMinutes",
            label: "Remember Login Minutes",
            fullWidth: true,
            required: true,
            InputProps: {
              inputComponent: DecimalInput,
            },
            inputProps: {
              decimalScale: 0,
              allowNegative: false,
            },
          },
          grid: { xs: 6 },
        },
        {
          input: {
            InputComponent: TextInputWithError,
            name: "maxInactivityMinutes",
            label: "Max Inactivity Minutes",
            fullWidth: true,
            required: true,
            InputProps: {
              inputComponent: DecimalInput,
            },
            inputProps: {
              decimalScale: 0,
              allowNegative: false,
            },
          },
          grid: { xs: 6 },
        },
      ],
    },
  ],
};

export const EditScope = ({ scope, handleEditScope, closeModalDialog }) => {
  return (
    <FormikForm
      initialValues={scope}
      onSubmit={handleEditScope}
      validationSchema={BWModels.loadSchema("Scope")}
    >
      {({ handleSubmit, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={closeModalDialog}
            sendButtonText="Save"
            listeners={[scopeDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};
